import { sanitizeHtml } from '../../common/safe-html.js';

export interface KvkkBannerOptions {
  htmlContent: string;
}

export function createKvkkBanner(options: KvkkBannerOptions): HTMLElement {
  const banner = document.createElement('div');
  banner.className = 'gengage-chat-kvkk-banner';
  banner.dataset['gengagePart'] = 'kvkk-banner';
  banner.setAttribute('role', 'note');

  const content = document.createElement('div');
  content.className = 'gengage-chat-kvkk-content';
  content.dataset['gengagePart'] = 'kvkk-content';
  content.innerHTML = sanitizeHtml(options.htmlContent);
  banner.appendChild(content);

  return banner;
}
